import React, { useState } from "react";
import { format } from "date-fns";
import { Grid, Header, Button, Tab } from "semantic-ui-react";
import ProfileForm from "./ProfileForm";

export default function MyDetailsTab({ profile, isCurrentUser }) {
  const [editMode, setEditMode] = useState(false);

  return (
    <Tab.Pane>
      <Grid>
        <Grid.Column width={16}>
          <Header
            floated="left"
            icon="user"
            content={`${profile.displayName}`}
          />
          {isCurrentUser &&
          <Button
            onClick={() => setEditMode(!editMode)}
            floated="right"
            basic
            content={editMode ? "Cancel" : "Edit"}
          />}
        </Grid.Column>
        <Grid.Column width={16}>
          {editMode ? (
            <ProfileForm profile={profile} />
          ) : (
            <>
              <div style={{ marginBottom: 10 }}>
                <strong>
                  Member since: {format(profile.createdAt, "dd MM yyyy")}
                </strong>
              </div>
              <div>
                <strong>Display name: {profile.displayName}</strong>
              </div>
            </>
          )}
        </Grid.Column>
      </Grid>
    </Tab.Pane>
  );
}
